import api from "@/lib/axios";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";
import { columns } from "./partial/Columns";
import { DataTable } from "./partial/DataTable";
import { useTahun } from "@/hooks/useTahun";

const getListDataPendaftaran = async (
  page: string,
  rowsPerPage: string,
  searchQuery: string,
  idsProgram?: string,
  statusValidasi?: string,
  tahunParams?: string,
) => {
  const response = await api.get(
    "/operator-student-exchange/data-pendaftaran/index",
    {
      params: {
        page,
        rowsPerPage,
        searchQuery,
        id_programs: idsProgram,
        status_validasi: statusValidasi,
        tahun: tahunParams,
      },
      withCredentials: true,
    },
  );

  return response.data?.data;
};

export default function DataPendaftaranStudentExchangePage() {
  const [searchParams] = useSearchParams();
  const pageParams = searchParams.get("page");
  const rowsPerPageParams = searchParams.get("rowsPerPage");
  const searchQueryParams = searchParams.get("search");
  const idsProgram = searchParams.get("ids_program");
  const statusValidasiParams = searchParams.get("status_validasi");

  const { selectedTahun } = useTahun();

  const { data, isPending } = useQuery({
    queryKey: [
      "listDataPendaftaran",
      pageParams,
      rowsPerPageParams,
      searchQueryParams,
      idsProgram,
      statusValidasiParams,
      selectedTahun?.label,
    ],
    queryFn: () =>
      getListDataPendaftaran(
        pageParams as string,
        rowsPerPageParams as string,
        searchQueryParams as string,
        idsProgram as string,
        statusValidasiParams as string,
        selectedTahun?.label as string,
      ),
  });

  return (
    <div>
      <DataTable
        data={data?.data || []}
        paginationData={data}
        columns={columns}
        isPending={isPending}
      />
    </div>
  );
}
``;
